import React from 'react';
import { AnimatedSection, AnimatedItem } from './AnimatedSection';
import { CheckCircle2 } from 'lucide-react';
export function WhatYoullLearn() {
  const items = ['Cómo reconocer y sanar heridas profundas de la infancia', 'Estrategias prácticas para romper el ciclo del silencio', 'Herramientas diarias de empoderamiento personal', 'Técnicas de autocuidado, compasión y resiliencia', 'Cómo construir y mantener relaciones saludables', 'El poder transformador de contar tu propia historia', 'Identificación y establecimiento de límites seguros', 'Prácticas para reconectar con tu niño interior'];
  return <section className="bg-cream py-24 px-6" data-id="element-248">
      <div className="max-w-5xl mx-auto" data-id="element-249">
        <AnimatedSection className="text-center mb-16" data-id="element-250">
          <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-251">
            Lo Que Aprenderás
          </h2>
          <p className="text-lg text-medium-brown max-w-2xl mx-auto" data-id="element-252">
            Una guía paso a paso diseñada para acompañarte en tu proceso de
            recuperación, ofreciéndote herramientas prácticas y apoyo emocional.
          </p>
        </AnimatedSection>

        <AnimatedSection stagger className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-253">
          {items.map((item, index) => <AnimatedItem key={index} className="bg-white p-6 rounded-2xl shadow-warm flex items-start space-x-4 border border-warm-beige/50" data-id="element-254">
              <CheckCircle2 className="w-6 h-6 text-terracotta flex-shrink-0 mt-1" data-id="element-255" />
              <span className="text-lg text-deep-brown font-medium leading-relaxed" data-id="element-256">
                {item}
              </span>
            </AnimatedItem>)}
        </AnimatedSection>
      </div>
    </section>;
}